import type {
	BoardItemChildResponse,
	BoardItemListItemResponse,
} from "@/client";

const jsonHeaders = { Accept: "application/json" };

const readError = async (res: Response): Promise<{ message: string }> => {
	const body = (await res.json().catch(() => null)) as {
		message?: string;
	} | null;
	return { message: body?.message ?? "Request failed." };
};

export const getPublicBoard = async (boardId: string) => {
	const res = await fetch(`/api/public/boards/${encodeURIComponent(boardId)}`, {
		headers: jsonHeaders,
		credentials: "same-origin",
	});
	if (!res.ok) {
		return { data: undefined, error: await readError(res) };
	}
	return {
		data: (await res.json()) as BoardItemChildResponse,
		error: undefined,
	};
};

export const listPublicBoardClips = async (args: {
	path: { board_id: string };
	query?: {
		page?: number;
		sort?: string;
		asc?: boolean;
		search?: string;
	};
}) => {
	const params = new URLSearchParams();
	if (args.query?.page != null) {
		params.set("page", String(args.query.page));
	}
	if (args.query?.sort) {
		params.set("sort", args.query.sort);
	}
	if (args.query?.asc != null) {
		params.set("asc", String(args.query.asc));
	}
	if (args.query?.search) {
		params.set("search", args.query.search);
	}
	const qs = params.toString();
	const res = await fetch(
		`/api/public/boards/${encodeURIComponent(args.path.board_id)}/clips${qs ? `?${qs}` : ""}`,
		{ headers: jsonHeaders, credentials: "same-origin" },
	);
	if (!res.ok) {
		return { data: undefined, error: await readError(res) };
	}
	return {
		data: (await res.json()) as BoardItemListItemResponse[],
		error: undefined,
	};
};
